import Vue from 'vue';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'jquery/dist/jquery.min';
import 'selectize/dist/js/standalone/selectize.min';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

// - Global event bus
window.EventBus = new Vue({
  data() {
    return {
      creative: null,
      user: null,
    };
  },
});

// Firebase
firebase.initializeApp({
  apiKey: 'AIzaSyD5vmfDYMKkDpKWvIK78-e32UNQJ9ETR4E',
  authDomain: 'showroom-73f68.firebaseapp.com',
  databaseURL: 'https://showroom-73f68.firebaseio.com',
  projectId: 'showroom-73f68',
  storageBucket: 'showroom-73f68.appspot.com',
  messagingSenderId: '1007231759662',
});
window.firebase = firebase;

// - Firebase auth
firebase.auth().onAuthStateChanged((user) => {
  EventBus.user = user;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js